<template>
  <section class="userSteps">
    <Header />
    <div class="ContentBlock">
      <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg"> 
        <button type="button" class="close_btn">
          <vue-feather size="26" type="x"></vue-feather>
        </button>
      </div>
      <div class="messageBlock" v-if="store.error.msg">
        <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
      </div>
      <Form class="inputForm text-center" @submit="submit">
        <div class="mainTitle mb-md-5 mb-4">
          <h1 class="text-center mb-3 f-30">{{$t('forgot_pwd.text1')}}</h1>
          <p>{{$t('forgot_pwd.text2')}}</p>
        </div>
        
        <float-label class="form-group">
          <Field
            class="form-control"
            name="email"
            autofill="off"
            autocomplete="email"
            v-model="form.username"
            :placeholder="$t('forgot_pwd.text3')"
            rules="required|email"
          />
          <ErrorMessage name="email" class="text-danger" />
        </float-label>
        <div class="buttonElement mb-3">
          <button type="submit" class="grd_btn full_size">{{$t('forgot_pwd.text4')}}</button>
        </div>
        <div class="otherLogin text-center">
         <a :href="`${static_vars.domainURL}login`" class="underline">{{$t('forgot_pwd.text5')}}</a>
        </div>
     </Form>
    </div>
    <stepFooter />
  </section>
</template>

<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import stepFooter from "../../components/shared/step_footer";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form : {
        username : ''
      }
    }
  },
  methods:{
    submit(){
      let formData = {};
      formData['userIdentifier'] = this.form.username
      formData["entryUrl"] = this.static_vars.resetPasswordURL
      this.store.forgotPassword(formData,true,'')
    }
  },
  computed: {
    isActive() {
      return false
    }
  },
  components: {
    stepFooter,
    FloatLabel,
    Form,
    Field,
    ErrorMessage,
  },
}
</script>